import React, { ReactNode } from 'react';

import Box from '../Box/Box';
import InputError from '../InputError';
import componentName from './name';

type TSelectionGroupBase = {
  /** Error Text, provided from the outside */
  errorText?: string;
  children: ReactNode;
  display?: string;
  as?: 'fieldset';
};

const SelectionGroupBase = ({ children, errorText, as, ...rest }: TSelectionGroupBase) => (
  <Box {...rest} as={as || 'div'} name={componentName}>
    {errorText && <InputError errorText={errorText} />}
    {children}
  </Box>
);

export default SelectionGroupBase;
